import type { FileClonedResult } from "@/services/abstract/poc/messaging.service.interface";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-cloned' });

export const createFileClonedHandler = (): MessageHandler<FileClonedResult> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-cloned',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileClonedResult => {
    if (message.type !== 'file-cloned') {
      throw new Error(`Invalid message type: expected 'file-cloned', got '${message.type}'`);
    }

    const { cid, sender, timestamp } = message;
    log.info('Received file-cloned for CID:', cid, 'from', sender);

    return {
      cid,
      sender,
      messageTimestamp: timestamp
    };
  }
});
